import React from 'react';
import { Payslip } from '@assets/images';
import { PAY_FREQUENCY } from '@config/constants';
import { DOCUMENT_TYPES, UploadFormContainer } from '../components';
import { useController } from './hooks';
import {
  WeeklyPayslip,
  MonthlyPayslip,
  ForthNightPayslip,
} from './components';
import { ts } from './utils';

const type = DOCUMENT_TYPES.PAYSLIP;

export const UploadPayslip = () => {
  const {
    control,
    isLoading,
    clearField,
    onUploadError,
    OtherDocument,
    descriptionText,
    Weekly1Document,
    Weekly2Document,
    Weekly3Document,
    Weekly4Document,
    Monthly1Document,
    Monthly2Document,
    areDocumentsReady,
    incomePeriodicity,
    onRemoveCompleted,
    onUploadCompleted,
    ForthNight1Document,
    ForthNight2Document,
    ForthNight3Document,
    ForthNight4Document,
  } = useController();

  return (
    <UploadFormContainer
      t={ts}
      imageElement={<Payslip width="100%" height="100%" data-testid="image" />}
      type={type}
      descriptionText={descriptionText}
      areDocumentsReady={areDocumentsReady}
    >
      {PAY_FREQUENCY.MONTHLY === incomePeriodicity && (
        <MonthlyPayslip
          control={control}
          isDisabled={isLoading}
          clearField={clearField}
          onUploadError={onUploadError}
          otherIncomesDocument={OtherDocument}
          onRemoveCompleted={onRemoveCompleted}
          onUploadCompleted={onUploadCompleted}
          monthly1PayslipDocument={Monthly1Document}
          monthly2PayslipDocument={Monthly2Document}
        />
      )}
      {PAY_FREQUENCY.BIWEEKLY === incomePeriodicity && (
        <ForthNightPayslip
          control={control}
          isDisabled={isLoading}
          clearField={clearField}
          onUploadError={onUploadError}
          otherIncomesDocument={OtherDocument}
          onRemoveCompleted={onRemoveCompleted}
          onUploadCompleted={onUploadCompleted}
          monthly1PayslipDocument={ForthNight1Document}
          monthly2PayslipDocument={ForthNight2Document}
          monthly3PayslipDocument={ForthNight3Document}
          monthly4PayslipDocument={ForthNight4Document}
        />
      )}
      {PAY_FREQUENCY.WEEKLY === incomePeriodicity && (
        <WeeklyPayslip
          control={control}
          isDisabled={isLoading}
          clearField={clearField}
          onUploadError={onUploadError}
          otherIncomesDocument={OtherDocument}
          onRemoveCompleted={onRemoveCompleted}
          onUploadCompleted={onUploadCompleted}
          weekly1PayslipDocument={Weekly1Document}
          weekly2PayslipDocument={Weekly2Document}
          weekly3PayslipDocument={Weekly3Document}
          weekly4PayslipDocument={Weekly4Document}
        />
      )}
    </UploadFormContainer>
  );
};
